import getAPIEndpoint from "./APIEndpoint";

export interface ClientMember {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  clientId: number;
  role: string;
  lastActive: string;
  createdAt: string;
  updatedAt: string;
}

export interface ClientInfo {
  id?: number;
  name?: string;
  members: ClientMember[];
  clientId: number;
}

/**
 * Fetches Client information including name and members
 */
export const getClientInfo = async (): Promise<{
  success: boolean;
  data?: ClientInfo | ClientMember[];
  error?: string;
}> => {
  try {
    const response = await fetch(`${getAPIEndpoint()}/clients`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();

    // Handle the case where the API returns an array of members directly
    if (result.success && Array.isArray(result.data)) {
      return {
        success: true,
        data: {
          members: result.data,
          name: result.name,
          clientId: result.clientId,
        },
      };
    }

    return result;
  } catch (error) {
    console.error("Error fetching Client info:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
